import axios from "axios";

export async function pushEmail(
	email: string,
	urlParameters: Record<string, string>,
	lpDomain: string,
): Promise<string | false> {
	const url = new URL("https://dev.lead.pstbck.net/click/x1eysyrciksu8lk");

	url.searchParams.set("custom_1", urlParameters.cid ?? "");
	url.searchParams.set("custom_2", urlParameters.cmp_id ?? "");
	url.searchParams.set("custom_3", urlParameters.lp_id ?? "");
	url.searchParams.set("custom_4", urlParameters.offer_id ?? "");
	url.searchParams.set("custom_5", lpDomain);

	let country = urlParameters.ctr ?? "unknown";
	let sexualOrientation = urlParameters?.orientation?.split("-")[1];

	switch (sexualOrientation) {
		case "straight":
			sexualOrientation = "heterosexual";
			break;
		case "shemale":
			sexualOrientation = "transexual";
			break;
		case "gay":
			sexualOrientation = "homosexual";
			break;
		default:
			sexualOrientation = "heterosexual";
			break;
	}

	return axios
		.post(url.toString(), {
			email: email,
			country: country,
			gender: "unknown",
			username: "unknown",
			password: "unknown",
			password_confirmation: "unknown",
			sexual_orientation: sexualOrientation,
		})
		.then((response) => {
			return response.data.redirect_url || false;
		})
		.catch((error) => {
			console.error("Error:", error);
			return false;
		});
}
